import React from 'react';
import { ProductCategory } from 'api/types/product';
import { Tag, Typography } from 'ui-kit';

export const getCategoryForProductCard = (
  key: ProductCategory,
  subcategory?: string,
  description?: string,
  storeFront?: boolean,
): React.ReactNode => {
  if (key === ProductCategory.LP || key === ProductCategory.POLP || key === ProductCategory.LS) {
    return <Tag text={storeFront ? 'Curated by the host co.' : 'local vendor'} color="secondary" />;
  }

  if (key === ProductCategory.AF) {
    return 'Affiliate';
  }

  if (!key && description) {
    return (
      <Typography variant="body2" rows={2} className="ProductCardAdmin-content-description">
        {description}
      </Typography>
    );
  }

  if (!key) {
    return null;
  }

  return subcategory;
};

export const getOutOfStock = (hasQuantity: boolean, quantity: number, amount = 0) => {
  if (!hasQuantity) {
    return false;
  }
  if (amount > quantity) {
    return true;
  }
  return !Math.max(quantity, 0);
};
